/* 3D-Karussell auf der "Über uns"-Seite.
   Das JS liegt bewusst hier (nicht im Theme-Block), da Theme-Blöcke kein
   eingebettetes <script> erlauben. Es tut nur etwas, wenn .about-carousel
   auf der Seite vorhanden ist. */
(function () {
  function init(root) {
    if (!root || root.dataset.acReady) return;
    var ring = root.querySelector('.ac-ring');
    var stage = root.querySelector('.ac-stage');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.ac-card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ac-dot]'));
    var prevBtn = root.querySelector('[data-ac-prev]');
    var nextBtn = root.querySelector('[data-ac-next]');
    var n = cards.length;
    if (!ring || n === 0) return;
    root.dataset.acReady = '1';

    var current = 0;
    var half = Math.floor(n / 2);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Cards sit on a circle (like a real carousel). Recomputed in measure().
    var R = 620;       // circle radius
    var stepDeg = 33;  // angle between neighbouring cards
    var DEG = Math.PI / 180;

    function activeIndex() { return ((current % n) + n) % n; }

    function render() {
      var a = activeIndex();
      cards.forEach(function (c, i) {
        // Signed distance from the active card, wrapped to the shortest way.
        var o = i - a;
        if (o > half) o -= n;
        else if (o < -half) o += n;

        // If a card wraps from one far edge to the other, snap it without a
        // slide across the whole stage.
        var prev = c._acOffset;
        if (prev !== undefined && Math.abs(o - prev) > 1) {
          c.style.transition = 'none';
          requestAnimationFrame(function () { c.style.transition = ''; });
        }
        c._acOffset = o;

        var ax = Math.abs(o);
        // Place the card on the circle: front card faces the viewer flat, cards
        // further round sit deeper (smaller) and turn away — so the outermost
        // ones start disappearing inward, like a rotating carousel.
        var phi = o * stepDeg;
        var rad = phi * DEG;
        var x = R * Math.sin(rad);
        var z = R * Math.cos(rad) - R;
        var pop = o === 0 ? 30 : 0; // nudge the active card forward so it stays clear
        c.style.transformOrigin = 'center center';
        c.style.transform =
          'translateX(' + x + 'px) ' +
          'translateZ(' + (z + pop) + 'px) ' +
          'rotateY(' + phi + 'deg)';
        // Cards weiter als ein Schritt von der aktiven entfernt ganz
        // ausblenden - bei der starken rotateY-Drehung wirkten sie sonst nur
        // noch als dünner roter Rand-Strich am Bildschirmrand.
        c.style.opacity = reduce ? '1' : (ax <= 1 ? String(Math.max(0.5, 1 - ax * 0.12)) : '0');
        c.style.filter = ax === 0 ? 'none' : 'saturate(0.92) brightness(0.96)';
        c.style.zIndex = String(100 - ax);
        c.classList.toggle('is-active', o === 0);
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === a); });
    }

    function measure() {
      var cw = ring.getBoundingClientRect().width || 300;
      var cardW = parseFloat(getComputedStyle(cards[0]).width) || 320;
      R = cardW * 1.95;                 // circle radius relative to card size
      stepDeg = cw < 700 ? 30 : 34;     // wider angle on desktop = fuller circle
      render();
    }

    function go(dir) { current += dir; render(); }
    function goTo(i) { current += (i - activeIndex()); render(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    // Ziehen / Wischen: nach links ziehen -> nächste Karte kommt nach vorne.
    var startX = null;
    stage.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    window.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    if (reduce) ring.style.transition = 'none';
    window.addEventListener('resize', measure);
    measure();

    // Handy: kurz zeigen, dass man die Karten austauschen kann – einmal
    // sanft zur nächsten Karte und wieder zurück, kurz nach dem Laden.
    if (!reduce && window.matchMedia('(max-width: 749px)').matches) {
      setTimeout(function () { go(1); }, 900);
      setTimeout(function () { go(-1); }, 1700);
    }
  }

  function boot() {
    document.querySelectorAll('.about-carousel[data-ac]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
